<highcharts-chart [options]="chartOptions"
    style="width: 100%; display: block;"></highcharts-chart>